/**
 * id do catálogo → componente de página. A rota `/admin/<dominio>/<id>` nasce daqui +
 * do catálogo (`ferramentaRoutes`), nunca à mão em App.tsx — `ferramenta-pages.spec.ts`
 * assere a paridade dos dois lados (ferramenta sem página e página sem ferramenta
 * ficam vermelhas). D5, 30/Set/2026.
 */
import { Route } from 'react-router-dom';

import { ActionRiskCategoriesPage } from '../../../pages/ActionRiskCategoriesPage';
import { AgendaSetupPage } from '../../../pages/AgendaSetupPage';
import { BondTypeConfigsPage } from '../../../pages/BondTypeConfigsPage';
import { ClassificacaoPage } from '../../../pages/ClassificacaoPage';
import { GatilhosTenantPage } from '../../../pages/GatilhosTenantPage';
import { ImportCustomerBasePage } from '../../../pages/ImportCustomerBasePage';
import { OnCallSchedulePage } from '../../../pages/OnCallSchedulePage';
import { PersonaEditorPage } from '../../../pages/PersonaEditorPage';
import { PlaybookEditorPage } from '../../../pages/PlaybookEditorPage';
import { QuickRepliesPage } from '../../../pages/QuickRepliesPage';
import { TemplatesMetaPage } from '../../../pages/TemplatesMetaPage';
import { TimesRoteamentoPage } from '../../../pages/TimesRoteamentoPage';
import { TransitionMatrixPage } from '../../../pages/TransitionMatrixPage';

import { DOMINIOS, FERRAMENTAS } from './catalog';
import { FerramentaPage } from './FerramentaPage';

export const FERRAMENTA_PAGES: Record<string, () => JSX.Element> = {
  'importar-base': ImportCustomerBasePage,
  playbooks: PlaybookEditorPage,
  personas: PersonaEditorPage,
  'matriz-transicao': TransitionMatrixPage,
  'risco-de-acao': ActionRiskCategoriesPage,
  'quick-replies': QuickRepliesPage,
  classificacao: ClassificacaoPage,
  gatilhos: GatilhosTenantPage,
  bonds: BondTypeConfigsPage,
  'times-roteamento': TimesRoteamentoPage,
  recursos: AgendaSetupPage,
  plantao: OnCallSchedulePage,
  'templates-meta': TemplatesMetaPage,
};

/** Fragmento para dentro de `<Route path="admin">` — path relativo `<dominio>/<id>`. */
export function ferramentaRoutes(): JSX.Element {
  return (
    <>
      {FERRAMENTAS.map((f) => {
        const Page = FERRAMENTA_PAGES[f.id]!;
        const dominio = DOMINIOS.find((d) => d.id === f.dominio)!;
        return (
          <Route
            key={f.id}
            path={`${dominio.id}/${f.id}`}
            element={
              <FerramentaPage id={f.id}>
                <Page />
              </FerramentaPage>
            }
          />
        );
      })}
    </>
  );
}
